export const DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ','];
export const OPERATORS = ['/', '*', '+', '-'];
export const RESULT_KEYS = ['=', 'Enter'];
export const CLEAR_KEYS = ['Escape'];
export const ERASE_KEYS = ['Backspace'];
